import editorStyle from "../../reportWriter.module.css";

import { SectionData } from "../Section/Section";
import { useContext } from "react";
import { EditorContext } from "../../../../../../contexts/EditorContext";
import { Vulnerability } from "../../../../../../sdkStructs";

interface Props {
  vuln: Vulnerability;
  getOneSection: (data: SectionData) => React.ReactNode;
  id: number;

  scrollRef: React.Ref<HTMLDivElement>,
}

function VulnSections({ vuln, getOneSection, id, scrollRef }: Readonly<Props>) {
  const { saveVulnChanges } = useContext(EditorContext);

  return (
    <div ref={scrollRef} className={editorStyle.vulnWrapper}>
      <div className={editorStyle.sectionsWrapper}>
        {getOneSection({
          before: id + 1 + ". ",
          text: vuln.Name,
          tag: vuln.Tag ?? "RandomTag",
          header: true,
          id: 3 + id * 5,
          title: "",
          saveFunc: (text: string) => {
            saveVulnChanges({
              id: vuln.ID,
              name: text,
            });
          },
        })}
        {getOneSection({
          text: vuln.Description,
          id: 3 + id * 5 + 1,
          title: "Description",
          saveFunc: (text: string) => {
            saveVulnChanges({
              id: vuln.ID,
              description: text,
            });
          },
        })}
        {getOneSection({
          text: vuln.Severity,
          id: 3 + id * 5 + 2,
          title: "CVSS",
          isCvss: true,
          saveFunc: (text: string) => {
            saveVulnChanges({
              id: vuln.ID,
              severity: text,
            });
          },
        })}
        {getOneSection({
          text: vuln.Poc,
          id: 3 + id * 5 + 3,
          title: "Proof of Concept",
          saveFunc: (text: string) => {
            saveVulnChanges({
              id: vuln.ID,
              poc: text,
            });
          },
        })}
        {getOneSection({
          text: vuln.Countermeasures,
          id: 3 + id * 5 + 4,
          title: "Recommendations",
          saveFunc: (text: string) => {
            saveVulnChanges({
              id: vuln.ID,
              countermeasures: text,
            });
          },
        })}
      </div>
    </div>
  );
}

export default VulnSections;
